export default __webpack_public_path__ + "puzzle.6f846586a682166538f04136253a40d1.svg";